import { PdfTableCell } from '@/components/pdf/PdfTableCell';
import { styles } from '@/components/pdf/styles';
import { Product } from '@/services/api/contracts/catalog/types';
import { Text, View } from '@react-pdf/renderer';
import { getNodeString } from '@udecode/plate-common';
import { FunctionComponent } from 'react';
import { PO_COMPLETE_DOCUMENT_SELECTED_DEVICE_FEE_TABLE_CELL_WIDTH } from './consts';

interface PurchaseOrderCompleteDocumentSelectedDeviceFeeTableProps {
  deviceFeeItem: Product;
}

const PurchaseOrderCompleteDocumentSelectedDeviceFeeTable: FunctionComponent<
  PurchaseOrderCompleteDocumentSelectedDeviceFeeTableProps
> = ({ deviceFeeItem }) => {
  const description = deviceFeeItem.description?.value?.map(n => getNodeString(n)).join(' ');

  return (
    <View
      style={{
        ...styles.table,
        width: PO_COMPLETE_DOCUMENT_SELECTED_DEVICE_FEE_TABLE_CELL_WIDTH * 2
      }}
    >
      <View style={styles.tableRow}>
        <PdfTableCell width={PO_COMPLETE_DOCUMENT_SELECTED_DEVICE_FEE_TABLE_CELL_WIDTH}>
          <Text style={styles.tableHeaderCell}>Selected Device Fee</Text>
        </PdfTableCell>
        <PdfTableCell lastCell width={PO_COMPLETE_DOCUMENT_SELECTED_DEVICE_FEE_TABLE_CELL_WIDTH} height={20}>
          <Text style={styles.tableHeaderCell}>Description</Text>
        </PdfTableCell>
      </View>
      <View style={styles.tableRow}>
        <PdfTableCell width={PO_COMPLETE_DOCUMENT_SELECTED_DEVICE_FEE_TABLE_CELL_WIDTH}>
          <Text style={styles.tableCell}>{deviceFeeItem.name}</Text>
        </PdfTableCell>
        <PdfTableCell lastCell width={PO_COMPLETE_DOCUMENT_SELECTED_DEVICE_FEE_TABLE_CELL_WIDTH}>
          <Text style={{ ...styles.tableCell, minHeight: 20 }}>{description}</Text>
        </PdfTableCell>
      </View>
    </View>
  );
};

export default PurchaseOrderCompleteDocumentSelectedDeviceFeeTable;
